import React, { useMemo, useState } from "react";
import { Card } from "react-bootstrap";
import { Box, IconButton, Typography } from "@mui/material";
import Skeleton from "@material-ui/lab/Skeleton";
import { ASSETS } from "../../utils/config";
import { useNavigate } from "react-router-dom";
import CreateEditBusinessBox from "./CreateEditBusinessBox";
import { Button } from "@material-ui/core";
import { isEmpty } from "lodash";
import { socialPlatforms } from "./BusinessBoxHelpers";
import "./styles.css";
import CloseIcon from "@mui/icons-material/Close";
import KeyboardBackspaceRoundedIcon from "@mui/icons-material/KeyboardBackspaceRounded";

export default function BusinessBoxPreview({
  isLoading,
  setIsLoading,
  onlyBusinessBox,
  noBusinessBox = false,
  businessBoxData,
  refetch,
  noEdit = false,
  handlePopupClick,
  PopupType,
  scrollable = false,
  handleFirstBbox,
  isTooltip = false,
  hideFromProfile,
}) {
  const [openBBModal, setOpenBBModal] = useState(false);

  const handleOpen = () => setOpenBBModal(true);
  const handleClose = () => {
    setOpenBBModal(false);
  };

  const initialValues = useMemo(
    () => (!isEmpty(businessBoxData) ? businessBoxData : null),
    [businessBoxData]
  );

  const refetchData = async () => {
    setIsLoading(true);
    await refetch();
    setIsLoading(false);
  };

  const renderCardContent = () => {
    return (
      <>
        <CreateEditBusinessBox
          showHeader={false}
          initialValues={initialValues}
          refetch={refetchData}
          open={openBBModal}
          onClose={handleClose}
          isFirstBbox={noBusinessBox}
          handleFirstBbox={handleFirstBbox}
        />
        <div style={{ height: "20px" }}></div>

        <Card
          style={{
            width: isTooltip ? "290px" : "100%",
            // maxHeight: "95vh",
            borderRadius: "20px",
            margin: "auto",
            paddingTop: "20px",
            border: "1px solid var(--Stroke-Grey, #E1E1E1)",
            backgroundColor: "#F6F7F9",
            cursor: "default",
            opacity: hideFromProfile ? "0.7" : "1",
          }}
        >
          {hideFromProfile && (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <img
                src={ASSETS.noPreview}
                alt="no preview"
                style={{
                  height: "142px",
                  width: "158px",
                  position: "absolute", // Position absolute for the icon to float over content
                  top: "50%", // 50% from the top
                  left: "50%", // 50% from the left
                  transform: "translate(-50%, -50%)", // Translate to center from its own position
                  zIndex: 2, // Higher than the rest of the elements
                }}
              />
            </Box>
          )}
          <div
            style={
              scrollable
                ? {
                    maxHeight: "58vh",
                    overflowY: "auto",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }
                : {
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }
            }
          >
            {noBusinessBox ? (
              <>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "center",
                    margin: "5px",
                    marginLeft: "10px",
                  }}
                >
                  <img
                    src={ASSETS.businessbox}
                    alt="titleImg"
                    style={{
                      width: "27px",
                      height: "21px",
                      marginRight: "5px",
                    }}
                  />
                  <Typography
                    variant="h6"
                    style={{
                      fontSize: "14px",
                      fontFamily: "DM Sans",
                      lineHeight: "17px",
                      fontWeight: "500",
                    }}
                  >
                    Business Box
                  </Typography>
                </div>

                <div
                  style={{
                    justifyContent: "center",
                    alignItems: "center",
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    marginTop: "80px",
                    marginBottom: "80px",
                  }}
                >
                  <img
                    src={ASSETS.noBusinessbox}
                    alt="empty"
                    style={{
                      height: "72px",
                      width: "88px",
                      marginBottom: "20px",
                    }}
                  />
                  <Typography
                    variant="h6"
                    style={{
                      fontSize: "14px",
                      fontFamily: "DM Sans",
                      lineHeight: "17px",
                      fontWeight: "500",
                      textAlign: "center",
                      marginBottom: "30px",
                    }}
                  >
                    No Business Box <br /> Created Yet
                  </Typography>
                  {noEdit ? null : (
                    <Button
                      variant="contained"
                      fullWidth
                      onClick={handleOpen}
                      style={{
                        border: "0.5px solid #123051",
                        borderRadius: "20px",
                        textTransform: "capitalize",
                        fontSize: "8px",
                        fontFamily: "DM Sans",
                        height: "19px",
                        backgroundColor: "#123051",
                        margin: "5px",
                        color: "white",
                        width: "120px",
                      }}
                    >
                      Create
                    </Button>
                  )}
                </div>
              </>
            ) : (
              <>
                {handlePopupClick && !noEdit && (
                  <Box
                    sx={{
                      width: "150px !important",
                      height: "20px !important",
                      padding: "10px 62px !important",
                      display: "flex !important",
                      alignItems: "center !important",
                      justifyContent: "center !important",
                      gap: "5px !important",
                      borderRadius: "20px !important",
                      border: "0.5px solid var(--Light-Grey, #BBB) !important",
                      background: "var(--Background, #F6F7F9) !important",
                      marginBottom: "20px",
                      cursor: "pointer",

                      "&:hover": {
                        boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)", // Customize as needed
                      },
                    }}
                    onClick={handlePopupClick}
                  >
                    <IconButton
                      size="small"
                      sx={{
                        width: "20px !important",
                        height: "20px !important",
                      }}
                    >
                      {PopupType === "exit" && (
                        <CloseIcon
                          sx={{
                            width: "11px !important",
                            height: "11px !important",
                          }}
                        />
                      )}
                      {PopupType === "load" && (
                        <KeyboardBackspaceRoundedIcon
                          sx={{
                            width: "15px !important",
                            height: "15px !important",
                          }}
                        />
                      )}
                    </IconButton>
                    <Typography
                      variant="body2"
                      sx={{
                        color: "#565556 !important",
                        textAlign: "center !important",
                        fontFamily: "DM Sans !important",
                        fontSize: "11px !important",
                        fontStyle: "normal !important",
                        fontWeight: "400 !important",
                        // lineHeight: "20px !important",
                        letterSpacing: "-0.16px !important",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {PopupType === "exit"
                        ? "Exit Preview Mode"
                        : "Change business box"}
                    </Typography>
                  </Box>
                )}

                <Card.Img
                  variant="top"
                  src={initialValues?.business_image}
                  style={{
                    height: "60px",
                    width: "60px",
                    margin: "auto",
                    borderRadius: "50%",
                    objectFit: "cover",
                  }}
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src =
                      "https://upload.wikimedia.org/wikipedia/commons/thumb/6/65/No-Image-Placeholder.svg/1665px-No-Image-Placeholder.svg.png";
                  }}
                />
                <Card.Title
                  style={{
                    fontSize: "16px",
                    lineHeight: "20px",
                    fontWeight: "500px",
                    fontFamily: "DM Sans",
                    textAlign: "center",
                    color: "#123051",
                    marginTop: "10px",
                  }}
                >
                  {initialValues?.name || "N/A"}
                </Card.Title>

                {!noEdit && (
                  <img
                    src={ASSETS.edit}
                    onClick={handleOpen}
                    alt={"Favourite"}
                    style={{
                      height: "15px",
                      width: "15px",
                      cursor: "pointer",
                      position: "absolute",
                      right: "20px",
                    }}
                  />
                )}

                {initialValues?.business_link?.length > 0 && (
                  <div style={{ display: "flex", margin: "auto" }}>
                    {initialValues.business_link.map((linkItem) => {
                      const platform = socialPlatforms.find(
                        (platform) => platform.name === linkItem.platform
                      );

                      if (!platform) return null;

                      // Ensure the link is an absolute URL
                      const isAbsoluteUrl = /^(http|https):\/\//.test(
                        linkItem.link
                      );
                      const href = isAbsoluteUrl
                        ? linkItem.link
                        : `https://${linkItem.link}`;

                      return (
                        <a
                          key={linkItem.id}
                          href={href}
                          target="_blank"
                          rel="noreferrer"
                          style={{ marginRight: "10px" }}
                          className="urlsOnPreview"
                        >
                          <img
                            alt={linkItem.platform.toLowerCase()}
                            style={{
                              height: "20px",
                              width: "20px",
                            }}
                            src={platform.icon}
                          />
                        </a>
                      );
                    })}
                  </div>
                )}

                {initialValues?.business_title && (
                  <span
                    style={{
                      fontSize: "12px",
                      lineHeight: "14.5px",
                      fontWeight: "400px",
                      fontFamily: "DM Sans",
                      textAlign: "center",
                      color: "#123051",
                      marginTop: "10px",
                    }}
                  >
                    {initialValues?.business_title}
                  </span>
                )}

                <div
                  style={{
                    display: "flex",
                    margin: "auto",
                    flexDirection: "column",
                    width: "100%",
                  }}
                >
                  {initialValues?.business_email && (
                    <span
                      style={{
                        fontSize: "12px",
                        lineHeight: "14.5px",
                        fontWeight: "400",
                        fontFamily: "DM Sans",
                        textAlign: "center",
                        color: "#0058B8",
                        marginTop: "10px",
                      }}
                    >
                      {initialValues?.business_email}
                    </span>
                  )}

                  {initialValues?.business_url && (
                    <a
                      href={initialValues?.business_url}
                      target="blank"
                      className="urlsOnPreview"
                      style={{
                        fontSize: "12px",
                        lineHeight: "14.5px",
                        fontWeight: "400",
                        fontFamily: "DM Sans",
                        textAlign: "center",
                        color: "#0058B8",
                        marginTop: "10px",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        display: "block",
                        cursor: "pointer",
                        textDecoration: "none",
                      }}
                      title={initialValues?.business_url}
                    >
                      {initialValues?.business_url}
                    </a>
                  )}
                </div>

                <Card.Body>
                  <div
                    style={{
                      padding: "20px",
                      backgroundColor: "#e3e5e8",
                      border: "1px solid transparent",
                      borderRadius: "13px",
                      width: isTooltip ? "250px" : "12vw",
                      // width: "250px",
                    }}
                  >
                    <div
                      style={{
                        maxWidth: "224px",
                      }}
                    >
                      <Typography
                        variant="subtitle2"
                        component="subtitle2"
                        color="#123051"
                        style={{
                          fontSize: "12px",
                          fontFamily: "DM Sans",
                          color: "#123051",
                          whiteSpace: "pre-wrap",
                          overflowWrap: "break-word",
                        }}
                      >
                        {initialValues?.description}
                      </Typography>
                    </div>

                    {initialValues?.advert_image && (
                      <img
                        style={{
                          marginTop: "12px",
                          width: "100%",
                          borderRadius: "5px",
                        }}
                        src={initialValues?.advert_image}
                        alt="featureImg"
                      />
                    )}

                    {/* <div
                      style={{
                        paddingTop: "12px",
                        width: "100%",
                        backgroundImage: `url(${initialValues?.advert_image})`,
                        backgroundSize: "contain",
                        backgroundPosition: "center center",
                        backgroundRepeat: "no-repeat",
                      }}
                    /> */}
                  </div>
                </Card.Body>
              </>
            )}
          </div>
        </Card>
      </>
    );
  };

  const renderLoader = () => {
    return (
      <Card style={{ width: "90%", borderRadius: "31px", margin: "auto" }}>
        {onlyBusinessBox ? null : (
          <>
            <Skeleton
              variant="rect"
              width={"90%"}
              height={150}
              style={{ borderRadius: "20px", margin: "5%" }}
            />
            <Skeleton style={{ borderRadius: "20px", margin: "5%" }} />
          </>
        )}
        <Skeleton
          variant="rect"
          width={"90%"}
          height={350}
          style={{ borderRadius: "20px", margin: "5%" }}
        />
        {/* ... */}
      </Card>
    );
  };
  return <>{isLoading ? renderLoader() : renderCardContent()}</>;
}
